import React, { useState, useRef } from 'react';
import { View, TouchableOpacity, Animated, Text, StyleSheet, Dimensions } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

const SlideMenu = ({ navigation, setView, acceptedOrders = [] }) => {
  const [menuVisible, setMenuVisible] = useState(false); // Estado do menu
  const heightAnim = useRef(new Animated.Value(0)).current; // Altura inicial do menu (fechado)
  const screenWidth = Dimensions.get('window').width; // Largura da tela

  const toggleMenu = () => {
    if (menuVisible) {
      // Fecha o menu (esconde)
      Animated.timing(heightAnim, {
        toValue: 0, // Reduz altura do menu para 0
        duration: 400,
        useNativeDriver: false, // Use false porque estamos animando dimensões
      }).start(() => setMenuVisible(false)); // Atualiza o estado após animação
    } else {
      setMenuVisible(true); // Define estado antes da animação
      // Abre o menu (expande)
      Animated.timing(heightAnim, {
        toValue: 330, // Altura ajustada para incluir todas as opções com um pequeno espaçamento
        duration: 400, // Duração ajustada para suavidade
        useNativeDriver: false, // Use false porque estamos animando dimensões
      }).start();
    }
  };

  return (
    <View style={[styles.container, { right: screenWidth > 768 ? 10 : -10 }]}>
      {/* Botão de abrir/fechar menu */}
      <TouchableOpacity style={styles.menuButton} onPress={toggleMenu}>
        <MaterialIcons name={menuVisible ? 'close' : 'menu'} size={24} color="#FFF" />
        <Text style={styles.menuButtonText}>{menuVisible ? 'Fechar' : 'Menu'}</Text>
        {acceptedOrders.length > 0 && (
          <View style={styles.notificationBadge}>
            <Text style={styles.notificationText}>{acceptedOrders.length}</Text>
          </View>
        )}
      </TouchableOpacity>

      {/* Menu deslizante */}
      <Animated.View
        style={[
          styles.menu,
          {
            height: heightAnim,
            width: screenWidth > 768 ? 220 : 180, // Largura ajustada para dispositivos menores
            borderWidth: menuVisible ? 2 : 0, // Bordas só aparecem quando o menu está visível
          },
        ]}
      >
        {menuVisible && (
          <>
            <TouchableOpacity
              style={styles.menuOption}
              onPress={() => {
                setView('createOrder');
                toggleMenu();
              }}
            >
              <MaterialIcons name="add-circle-outline" size={24} color="#FFF" />
              <Text style={styles.menuOptionText}>Criar Pedido</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuOption}
              onPress={() => {
                setView('pending');
                toggleMenu();
              }}
            >
              <MaterialIcons name="assignment" size={24} color="#FFF" />
              <Text style={styles.menuOptionText}>Pendentes</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuOption}
              onPress={() => {
                setView('accepted');
                toggleMenu();
              }}
            >
              <MaterialIcons name="check-circle-outline" size={24} color="#FFF" />
              <Text style={styles.menuOptionText}>Aceitos</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuOption}
              onPress={() => {
                setView('completed');
                toggleMenu();
              }}
            >
              <MaterialIcons name="history" size={24} color="#FFF" />
              <Text style={styles.menuOptionText}>Histórico</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuOption}
              onPress={() => {
                navigation.navigate('GainsScreen');
                toggleMenu();
              }}
            >
              <MaterialIcons name="bar-chart" size={24} color="#FFF" />
              <Text style={styles.menuOptionText}>Ganhos</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.menuOption}
              onPress={() => {
                setView('profile');
                toggleMenu();
              }}
            >
              <MaterialIcons name="person-outline" size={24} color="#FFF" />
              <Text style={styles.menuOptionText}>Perfil</Text>
            </TouchableOpacity>
          </>
        )}
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 60, // Botão permanece mais abaixo
    zIndex: 100,
  },
  menuButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#28a745',
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 25,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 5,
  },
  menuButtonText: {
    color: '#FFF',
    fontSize: 16,
    marginLeft: 10,
  },
  notificationBadge: {
    position: 'absolute',
    top: 5,
    right: 5,
    backgroundColor: 'red',
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  notificationText: {
    color: '#FFF',
    fontSize: 12,
    fontWeight: 'bold',
  },
  menu: {
    backgroundColor: '#2c5364',
    borderRadius: 10,
    overflow: 'hidden', // Para esconder conteúdo quando o menu está fechado
    borderColor: '#FFF', // Cor da borda
  },
  menuOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 10,
  },
  menuOptionText: {
    color: '#FFF',
    marginLeft: 10,
    fontSize: 16,
  },
});

export default SlideMenu;
